import makeEvent from './makeEvent';
import {
  ElementClicked,
  ElementEvents,
  ElementViewed,
  UseElementEvents,
} from './types';
import { EVENTS } from './types/events';

const elementEvents: UseElementEvents = (data) => {
  const elementEvent = makeEvent<ElementEvents, EVENTS>(data);
  return {
    elementClicked: elementEvent<ElementClicked>(EVENTS.ElementClicked),
    elementViewed: elementEvent<ElementViewed>(EVENTS.ElementViewed),
  };
};

export default elementEvents;
